





























import { Component, Vue } from 'vue-property-decorator'
import Menu from '@/components/Container/Menu.vue'
import H5Menu from '@/components/Container/H5Menu.vue'
import { login, getUserInfo, loginout } from '@/api/api'

@Component({
  components: {
    Menu,
    H5Menu
  }
})
export default class Login extends Vue {
  userInfo: any = ''
  searchCourse: string = ''
  menuIndex: string = 'Main'

  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo)
    // console.log(this.userInfo)
  }

  logout() {
    this.$confirm('是否确认退出登录?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      loginout().then((res: any) => {
        let url = window.location.href.split('?')
        if (url.length === 1) {
          this.$router.push({ name: 'Login' })
        } else {
          window.location.href = url[0]
        }
        sessionStorage.clear()
      })
    })
  }

  /**
   * 个人中心
   */
  toPersonalCenter() {
    this.$router.push({
      path: '/PersonalCenter'
    })
  }

  selectMenu(e: string) {
    this.menuIndex = e
    console.log(e)
  }
}
